import {
  ADD_COLLATERALS_REQUEST,
  ADD_COLLATERALS_SUCCESS,
  ADD_COLLATERALS_ERROR,
  GET_COLLATERALS_REQUEST,
  GET_COLLATERALS_SUCCESS,
  GET_COLLATERALS_ERROR,
  DELETE_COLLATERALS_REQUEST,
  DELETE_COLLATERALS_SUCCESS,
  DELETE_COLLATERALS_ERROR
} from "./types";
import axios from "axios";
import { BASEURL } from "../../constant/config.js";

export const uploadCollaterals = (token, formData) => (dispatch) => {
  dispatch({ type: ADD_COLLATERALS_REQUEST });
  return axios({
    method: "POST",
    url: `${BASEURL}uploads/collateral/1`,
    data: formData,
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + token,
      "Content-Type": "multipart/form-data"
    },
  })
    .then((response) => {
      return dispatch({
        type: ADD_COLLATERALS_SUCCESS,
        payload: response.data,
      });
    })
    .catch((error) => {
      dispatch({
        type: ADD_COLLATERALS_ERROR,
        payload: [],
      });
    });
};


export const getCollaterals = (token) => (dispatch) => {
  dispatch({ type: GET_COLLATERALS_REQUEST });
  return axios({
    method: "POST",
    url: `${BASEURL}getAll/Collaterals`,
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
  })
    .then((response) => {
      return dispatch({
        type: GET_COLLATERALS_SUCCESS,
        payload: response.data,
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_COLLATERALS_ERROR,
        payload: [],
      });
    });
};

export const deleteCollaterals = (token, id) => (dispatch) => {
  dispatch({ type: DELETE_COLLATERALS_REQUEST });
  return axios({
    method: "DELETE",
    url: `${BASEURL}delete/Collaterals/${id}`,
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
  })
    .then((response) => {
      return dispatch({
        type: DELETE_COLLATERALS_SUCCESS,
        payload: response.data
      });
    })
    .catch((error) => {
      return dispatch({
        type: DELETE_COLLATERALS_ERROR,
        payload: error.response,
      });
    });
};